document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    if (window.parent === window) return
    const message = {
      type: 'clara-navigate',
      path: window.location.pathname.substring(1), // Removing leading '/'
      params: window.location.search.substring(1), // Removing leading '?'
      hash: window.location.hash.substring(1) // Removing leading '#'
    }
    window.parent.postMessage(message, '*')
  }, 100)

  setInterval(function () {
    if (window.parent === window) return
    const selection = document.querySelectorAll('[data-scroll-offset]')[0]
    if (selection === undefined) return
    const height = selection.getBoundingClientRect().top
    const message = {
      type: 'clara-resize',
      height
    }
    window.parent.postMessage(message, '*')
  }, 250)
})
